import React, { useState } from "react";
import { makeStyles } from "@mui/styles";
import {
  Button,
  Card,
  CardContent,
  FormHelperText,
  Grid,
  Input,
  TextField,
} from "@mui/material";
import { callAPI } from "../../../../../App/Helpers/callApi";
import Signifier from "../../../../../App/Components/Signifier/Signifier";
import { useSelector } from "react-redux";
import { selectCareersClientValue } from "../../../../../App/State/Slices/SelectedCareersClientSlice";
import { getTemplate, uploadLocations } from "../../../LocationsService";

function UploadLocationsPage() {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "60%",
      marginBottom: "50px",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },
    cardContainer: {
      [theme.breakpoints.down("md")]: {
        width: "100%",
        overflowY: "scroll",
      },
      display: "flex",
      flexDirection: "column",
      marginBottom: "20px",
      width: "100%",
    },
    error: {
      color: theme.palette.error.main,
    },
  }));

  const classes = useStyles();

  const selectCareersClient = useSelector(selectCareersClientValue);
  const [showSignifier, setShowSignifier] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [processing, setProcessing] = useState(false);

  const [inputError, setInputError] = useState(false);
  const [fileName, setFileName] = useState("");
  const [file, setFile] = useState(null);

  function downloadTemplate() {
    getTemplate();
  }

  function submitFile() {
    let fileData = new FormData();
    fileData.append("FormFile", file);
    callAPI(
      uploadLocations(fileData, selectCareersClient.id),
      "Locations Uploaded",
      setShowSignifier,
      setResponseMessage,
      setShowError,
      setProcessing
    );
  }

  const uploadFile = (e) => {
    var fileName = e.target.files[0]?.name;

    if (fileName.substring(fileName.length - 4) !== ".csv") {
      setInputError(true);
      return;
    }
    setFileName(fileName);
    setFile(e.target.files[0]);
  };

  return (
    <>
      <Signifier
        showSignifier={showSignifier}
        setShowSignifier={setShowSignifier}
        message={responseMessage}
        error={showError}
      />
      <div className={classes.root}>
        <Card className={classes.card}>
          <CardContent>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={2}>
                <label htmlFor="contained-button-file">
                  <Input
                    accept="image/*"
                    id="contained-button-file"
                    multiple
                    type="file"
                    style={{ display: "none" }}
                    onChange={(e) => uploadFile(e)}
                  />
                  <Button
                    variant="contained"
                    color="primary"
                    component="span"
                    style={{ marginTop: "10px", whiteSpace: "nowrap" }}
                  >
                    Select File
                  </Button>
                </label>
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField
                  placeholder="File Name"
                  label="File Name"
                  variant="standard"
                  fullWidth
                  required
                  disabled
                  error={inputError}
                  value={fileName}
                />
                {inputError && (
                  <FormHelperText className={classes.error}>
                    Image Required
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={12} sm={12} container justifyContent="flex-end">
                <Button
                  style={{ marginTop: "20px", marginRight: "8px" }}
                  className={classes.sensitiveButton}
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={fileName === ""}
                  onClick={() => submitFile()}
                >
                  Upload
                </Button>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
        <Grid className={classes.cardContainer}>
          <Grid item xs={12} sm={12}>
            <Button
              style={{ marginTop: "20px" }}
              className={classes.sensitiveButton}
              type="submit"
              variant="contained"
              color="primary"
              onClick={() => downloadTemplate()}
            >
              Download Template File
            </Button>
          </Grid>
        </Grid>
      </div>
    </>
  );
}

export default UploadLocationsPage;
